import { useState } from "react";
import { useTranslation } from "react-i18next";

import {
  Autocomplete,
  Box,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";

import DatePickerComp, {
  DatePickerTypes,
} from "components/DatePicker/DatePicker";

interface MachineTemperatureDetailsProps {
  timezones: string[];
  id: string | undefined;
}
const MachineTemperatureDetails = ({
  id,
  timezones,
}: MachineTemperatureDetailsProps) => {
  const { t } = useTranslation();

  const [startDate, setStartDate] = useState<null | string>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [timezone, setTimezone] = useState<string>(localTimezone);
  const [isSelectedStartAndEndDate, setIsSelectedStartAndEndDate] =
    useState<boolean>(false);
  const [isSeleStartDay, setIsSelectedStartDay] = useState<boolean>(false);

  const getStarDay = (dates: Date | Date[] | null) => {
    if (Array.isArray(dates)) {
      setStartDate(dates[0].toISOString());
      setIsSelectedStartDay(true);
    }
  };
  const getEndDay = (dates: Date | Date[] | null) => {
    if (Array.isArray(dates) && isSeleStartDay) {
      setEndDate(dates[0].toISOString());
      setIsSelectedStartAndEndDate(true);
    }
  };
  return (
    <Grid container spacing={2} marginY={2}>
      <Grid item xs={12}>
        <Typography variant="h5" fontWeight={600} marginBottom={2}>
          {t("Machine temperature report")}
        </Typography>
        <Box
          sx={{
            backgroundColor: "white",
            boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.25)",
            padding: "20px",
          }}
        >
          <div style={{ width: "fit-content" }}>
            <div
              style={{
                display: "flex",
                gap: "20px",
                alignItems: "center",
                marginBottom: "20px",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                }}
              >
                {t("Start date")}:
              </Typography>
              <DatePickerComp
                type={DatePickerTypes.SINGLE_RANGED}
                onChange={getStarDay}
                isCentered={true}
                inlineStyle={{ width: "fit-content" }}
              />
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                  }}
                >
                  {t("End date")}:
                </Typography>

                <DatePickerComp
                  type={DatePickerTypes.SINGLE_RANGED}
                  onChange={getEndDay}
                  isCentered={true}
                  inlineStyle={{ width: "fit-content" }}
                  minDate={new Date(startDate ?? "")}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gap: "20px",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <div
                style={{ display: "flex", gap: "20px", alignItems: "center" }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                  }}
                >
                  {t("Timezone")}:
                </Typography>
                <Autocomplete
                  options={timezones}
                  value={timezone}
                  onChange={(event, newValue) => setTimezone(newValue ?? "")}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                  sx={{ width: "auto", minWidth: "200px" }} // по избор, задава ширина
                />
              </div>
            </div>

            <div
              style={{
                pointerEvents: !isSelectedStartAndEndDate ? "none" : "unset",
              }}
            >
              <a
                href={`${process.env.REACT_APP_BASE_URL}/api/machines/${id}/temperature-report?from=${startDate}&to=${endDate}&timezone=${timezone}`}
              >
                {!isSelectedStartAndEndDate
                  ? t("Select start and end date to download report")
                  : t("Download report")}
              </a>
            </div>
          </div>
        </Box>
      </Grid>
    </Grid>
  );
};
export default MachineTemperatureDetails;
